import React, { Component } from 'react';
import RemoteInputSelect from './RemoteInputSelect';
import Button from '../output/Button';
import PropTypes from 'prop-types';
import { Loader } from 'react-feather';
import { fetchGet } from '../../cruds/remote';
import getLabel from '../../translations/messages';
import dotAccess from 'dot-access';
import './CopyFrom.css';

class CopyFrom extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = { selected: null, copying: false, error: '' };
  }

  handleSelectChange = (e) => {
    this.setState({ selected: e.target.value });
  };

  handleCopy = () => {
    const enabled = this.state.selected !== null;

    if( enabled ) {
      this.setState(
        { copying: true, error: '' },
        this.handleActualCopy
      );
    }

  }

  handleActualCopy = () => {
    const { from, valueName, value, copyFrom, handleChange } = this.props;
    const filtered = dotAccess.get(value, valueName);
    const baseValue = filtered !== undefined && filtered !== null ? filtered : [];

    fetchGet(from + '/' + this.state.selected + '/' + copyFrom)
      .then(res => {
        const newValue = res.value.concat(baseValue.filter(v => res.value.indexOf(v) < 0));

        handleChange({ target: {
          name: valueName,
          value: newValue,
        }, });
        this.setState({ selected: '', copying: false });
      })
      .catch( err => {
        this.setState({
          selected: '',
          copying: false,
          error: getLabel(this.context.locale, 'departmentSubstances.copyError')
        });
      });
  };

  render() {
    const { from, param, optionValueName, optionLabelName, order } = this.props;
    const { selected, copying, error } = this.state
    const disabled = selected === null;

    return (
      <div className="CopyFrom">
        {copying ? <div className="loading"><Loader size={30} /></div> : ''}
        <div className="input-label">Copia da</div>
        <div className="container">
          <RemoteInputSelect from={from + '/simple'}
          	  order={order}
              name="copy-from"
              optionValueName={optionValueName}
              optionLabelName={optionLabelName}
              handleChange={this.handleSelectChange}
              param={param}
              value={this.state.selected}
          />
          <Button onClick={this.handleCopy} disabled={disabled? 'disabled' : ''}>Copia</Button>
        </div>
        {error? <div className="error-message">{error}</div> : ''}
      </div>
    );
  }

}

CopyFrom.contextTypes = {
  locale: PropTypes.string,
};

export default CopyFrom;



// WEBPACK FOOTER //
// ./src/main/components/input/CopyFrom.js